module.exports = __webpack_public_path__ + "media/img/pages/companies/lidl-f24b2f34c24415e42a32f966e758ea28.png";